module.exports = "/assets/02d7d359ebd5f39c5bff39c0c949bce6.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/VN.png
// module id = 3051
// module chunks = 0